import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ToggleApiKeyUseCaseInterface } from 'domain/usecases';

export class RemoteToggleApiKey implements ToggleApiKeyUseCaseInterface {
  constructor(
    private readonly baseUrl: string,
    private readonly httpClient,
  ) {}

  async execute(params: {
    id: string;
    active: boolean;
  }): Promise<ToggleApiKeyUseCaseInterface.Result> {
    const { id, ...body } = params;
    const httpResponse = await this.httpClient.request({
      url: `${this.baseUrl}/${id}/toggle`,
      method: 'patch',
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
